import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { ELLIPSIS_SX } from "@app/common/styles";

import { Column } from "@rui/Stack";

export const Card = styled(Column)(({ theme }) => ({
  backgroundColor: "#FFF",
  border: "1px solid",
  borderColor: theme.palette.transparent.black[8],
  padding: theme.spacing(2),
  borderRadius: "8px",
  boxShadow: "0px 4px 24px 0px #0000000A",
}));

export const SummaryText = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryReg,
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[800],
  "&.loose": {
    lineHeight: 21 / 14,
  },
}));

export const ExpandableSummaryText = styled(SummaryText)({
  "&.collapsed": {
    ...ELLIPSIS_SX,
    // if the browser supports line clamping, clamp to 2 lines instead of 1
    "@supports( -webkit-line-clamp: 2)": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "initial",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
    },
  },
});

export const EmptySummaryText = styled(SummaryText)(({ theme }) => ({
  color: theme.palette.shades.neutral[300],
  fontStyle: "italic",
}));

export const ExpandableSummaryContainer = styled(Column)({
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  position: "relative",
  "& .hidden": {
    visibility: "hidden",
  },
});
